export const checkIsFirstTwoLetters = (value: string) => {
  return /^[A-Za-z]{2}/.test(value);
};
